import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActivityRoutingModule } from './activity-routing.module';
import { ActivityComponent } from './activity.component';
import {MatIconModule} from '@angular/material/icon'
import { MatSelectModule } from '@angular/material/select';
import { ChildActivitiyComponent } from './child-activitiy/child-activitiy.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatProgressBarModule } from '@angular/material/progress-bar';
@NgModule({
  declarations: [
    ActivityComponent,
    ChildActivitiyComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    ActivityRoutingModule,
    MatIconModule,
    MatSelectModule,
    InfiniteScrollModule,
    MatProgressBarModule
  ],
  exports: [
    ActivityComponent
  ],
})
export class ActivityModule { }
